document.addEventListener("DOMContentLoaded", () => {
  const radioButtons = document.querySelectorAll('input[name="properties[Motiv]"]');
  const svgImage = document.querySelector("#dynamic-image");
  const generatePdfLink = document.querySelector("#generate-pdf-link");

  // Ladeanimation erstellen
  const loader = document.createElement("div");
  loader.id = "image-loader";
  loader.innerHTML = "Bild wird geladen...";
  loader.style.display = "none";
  loader.style.position = "fixed";
  loader.style.top = "50%";
  loader.style.left = "50%";
  loader.style.transform = "translate(-50%, -50%)";
  loader.style.padding = "12px 20px";
  loader.style.background = "rgba(0, 0, 0, 0.75)";
  loader.style.color = "#fff";
  loader.style.borderRadius = "8px";
  loader.style.zIndex = "9999";
  loader.style.fontSize = "14px";
  document.body.appendChild(loader);

  const setLoading = (isLoading) => {
    loader.style.display = isLoading ? "block" : "none";

    if (generatePdfLink) {
      generatePdfLink.style.pointerEvents = isLoading ? "none" : "auto";
      generatePdfLink.style.opacity = isLoading ? "0.5" : "1";
      generatePdfLink.setAttribute("aria-disabled", isLoading ? "true" : "false");
    }
  };

  const convertToBase64 = (url) =>
    fetch(url)
      .then((res) => res.blob())
      .then(
        (blob) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          })
      );

  const updateSVGImage = async (imageUrl) => {
    if (!svgImage) return;

    try {
      setLoading(true);

      const base64Image = await convertToBase64(imageUrl);
      svgImage.setAttribute("href", base64Image);
    } catch (error) {
      console.error("Fehler beim Laden des Bildes:", error);
    } finally {
      setLoading(false);
    }
  };

  radioButtons.forEach((radioButton) => {
    radioButton.addEventListener("change", async (event) => {
      const selectedImage = event.target.getAttribute("data-image");

      if (selectedImage) {
        await updateSVGImage(selectedImage);
      }
    });
  });

  const checkedRadioButton = document.querySelector('input[name="properties[Motiv]"]:checked');

  if (checkedRadioButton) {
    const initialImage = checkedRadioButton.getAttribute("data-image");

    if (initialImage) {
      updateSVGImage(initialImage);
    }
  }
});